import React, { useContext, useEffect, useState } from 'react';
import './Header.scss';
import { useNavigate } from 'react-router-dom';
import headerData from '../../../config/HeaderConfig.json';
// import headerData from '../../config/HeaderConfig.json';

import { FaBars, FaChevronDown, FaTimes, FaUser } from 'react-icons/fa';
// import countryFlag from '../../assets/Image/country_flag.svg';
// import omanFlag from '../../assets/Image/oman-flag-round-icon.svg';
// import globe from '../../assets/Image/lauguage_globe_icon.svg'
import globe from '../../../assets/Image/lauguage_globe_icon.svg'
import { translateDataToArabic } from '../../../helpers/usetranslateDataToArabic';
import RMSlogo from '../../../assets/Image/rmsLogo.jpg'

// import CustomModal from '../../Shared/CustomModal';
// import LoginPage from '../LoginPage';
// import GlobalContext from '../../context/GloblContext';
// import { translateDataToArabic } from '../../helpers/usetranslateDataToArabic';

const iconMap = {
  FaBars: <FaBars />,
  FaTimes: <FaTimes />,
  FaChevronDown: <FaChevronDown />,
  FaUser: <FaUser />,
};

const HeaderComponent = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  // const { setVehPlateNum, setVehPlateCode, setvehImages } = useContext(GlobalContext);
  const [isLogin, setIsLogin] = useState(false);
  const navigate = useNavigate();
  console.log("headerData<><>",headerData)

  const styles = headerData?.styles;
  const headerNavEN = headerData.navigation;

  const [headerNavData, setHeaderNavData] = useState(headerNavEN);
  const [currentLang, setCurrentLang] = useState(sessionStorage.getItem('language') || 'en');

  // ✅ Function to load language data from sessionStorage
  const loadLanguage = async () => {
    const lang = sessionStorage.getItem('language') || 'en';
    setCurrentLang(lang);

    if (lang === 'ar') {
      const translatedData = await translateDataToArabic(headerNavEN);
      setHeaderNavData(translatedData);
    } else {
      setHeaderNavData(headerNavEN);
    }
  };

  // ✅ Toggle between Arabic & English
  const handleTranslate = async () => {
    if (currentLang === 'ar') {
      sessionStorage.removeItem('language');
    } else {
      sessionStorage.setItem('language', 'ar');
    }
    // Trigger update immediately
    await loadLanguage();
  };

  // ✅ On Mount → Load stored language
  useEffect(() => {
    loadLanguage();
  }, []);

  // ✅ Listen for sessionStorage changes (even across tabs)
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'language') {
        loadLanguage();
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  // }, [isLogin]);
  return (
    <div>
      <header
        className="header"
        style={{
          backgroundColor: styles?.backgroundColor,
          color: styles?.textColor,
        }}
      >
        <nav className="nav">
          <button className="menu-toggle" onClick={toggleMenu} style={{ color: styles.textColor }}>
            {menuOpen
              ? iconMap[headerData?.icons?.menuOpen]
              : iconMap[headerData?.icons?.menuClosed]}
          </button>

          {/* Logo */}
          <div
            className="rmslogo"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              localStorage.clear();
              // setVehPlateNum('--');
              // setVehPlateCode('--');
              // navigate(headerData?.logo?.navigateTo);
              // setvehImages({
              //   front: null,
              //   back: null,
              //   left: null,
              //   right: null,
              // });
            }}
          >
            <img src={ RMSlogo} alt={headerData?.logo?.alt} />
          </div>

          {/* Navigation */}
          <ul className={`nav-list ${menuOpen ? 'open' : ''}`}>
            {(headerNavData || []).map((item, index) => (
              <li key={index}>
                <div className="list-dropdown" style={{ color: styles?.textColor }}>
                  <a
                    href={item.href}
                    target="_blank"
                    style={{ color: styles?.textColor }}
                    onMouseOver={(e) => (e.target.style.color = styles?.hoverColor)}
                    onMouseOut={(e) => (e.target.style.color = styles?.textColor)}
                  >
                    {item.label}
                  </a>
                  {item?.hasDropdown && iconMap[headerData?.icons?.dropdown]}
                </div>
              </li>
            ))}
          </ul>

          {/* Right side */}
          <div className="header-right" style={{ color: styles.textColor }}>
            {headerData.rightHeader.map((item, index) => {
              if (item?.type === 'icon') {
                return (
                  <div
                    key={index}
                    className="header-icon"
                    onClick={() => navigate(item?.navigateTo)}
                  >
                    {iconMap[item.icon]}
                  </div>
                );
              }
              if (item?.type === 'navtext') {
                return <div key={index} className="header-icon">{item?.text}</div>;
              }
              if (item?.type === 'language') {
                return (
                  <div
                    style={{ cursor: 'pointer' }}
                    key={index}
                    className="language-selector"
                    onClick={handleTranslate}
                  >
                    {currentLang === 'ar' ? (
                      <img src={globe} alt={headerData?.language?.alt} />
                    ) : (<img src={globe} alt="oman flag" />)
                    }
                    <span>{currentLang === 'ar' ? item?.label : 'AR'}</span>
                  </div>
                );
              }
              return null;
            })}
          </div>
        </nav>
      </header>

      {/* Login Modal */}
      {/* {isLogin && (
        <div className="signin-model">
          <CustomModal
            style={{ margin: '0 1rem' }}
            isOpen={isLogin}
            onClose={() => setIsLogin(false)}
            isCloseButton={true}
            headerName="Sign In"
          >
            <LoginPage isLogin={isLogin} />
          </CustomModal>
        </div>
      )} */}
    </div>
  );
};

export default HeaderComponent;
